<template>
  <el-dialog :title="id ? '编辑台班劳务' : '新增台班劳务'" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
    <el-form ref="formData" class="global-form3" :model="info" :rules="rules" label-position="right"
      label-width="110px">
      <div class="flex">
        <el-form-item label="所属项目" prop="projectId">
          <el-select v-model="info.projectId" filterable placeholder="请选择所属项目">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="machineTeamDate" label="台班日期">
          <el-date-picker v-model="info.machineTeamDate" type="date" :picker-options="pickerOptions"
            value-format="yyyy-MM-dd" placeholder="请选择台班日期">
          </el-date-picker>
        </el-form-item>
      </div>

      <el-form-item class="mb20" label="台班机械" prop="machineTeamLines">
        <div class="table">
          <div class="instructions mb20">
            <el-button type="primary" @click='onAdd'>新增</el-button>
          </div>
          <el-table class="global-table" max-height="400" :summary-method="getSummaries" show-summary
            :data="info.machineTeamLines" border ref="table">
            <el-table-column label="机械名称" prop="machineryName" align='center'>
              <template v-slot="{ row }">
                <el-form-item style="margin-bottom: 0;" :rules="rules.machineryId">
                  <el-select popper-class="machinery-select" filterable v-model="row.machineryId" placeholder="请选择"
                    @change="res => onMachineryChange(res, row)">
                    <el-option v-for="item of machineryData" :key="item.machineryId" :label="item.machineryName"
                      :value="item.machineryId">
                      <div class="machinery-item">
                        <div class="line1">
                          <span>{{ item.machineryName }}</span>
                          <span>{{ item.specificationModel }}</span>
                        </div>
                        <div class="line2">
                          <span>{{ item.supplierName ?? '/' }}</span>
                        </div>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="规格型号" prop="specificationModel" align='center'
              showOverflowTooltip></el-table-column>
            <el-table-column label="供应商名称" width="120" prop="supplierName" align='center'
              showOverflowTooltip></el-table-column>
            <el-table-column label="单价(元)" align='center' prop="price"></el-table-column>
            <el-table-column label="是否含油" align='center'>
              <template v-slot="{ row }">
                <el-tag type="success" v-if="row.whetherOil === '1'">是</el-tag>
                <el-tag type="danger" v-if="row.whetherOil === '2'">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="作业内容" prop="jobContent" align='center' showOverflowTooltip>
              <template v-slot="{ row, $index }">
                <el-form-item v-if="row.isEdit" style="margin-bottom: 0;" :rules='rules.jobContent'>
                  <el-input maxlength="300" v-model="row.jobContent" placeholder="请输入"></el-input>
                </el-form-item>
                <span v-else class="overoverflow_H">{{ row.jobContent }}</span>
              </template>
            </el-table-column>
            <el-table-column label="台班/小时数" prop="hours" align='center' showOverflowTooltip>
              <template v-slot="{ row, $index }">
                <el-form-item v-if="row.isEdit" style="margin-bottom: 0;" :rules='rules.hours'>
                  <el-input maxlength="20" v-model="row.hours" placeholder="请输入"
                    @input="val => hoursChange(val, row)"></el-input>
                </el-form-item>
                <span v-else class="overoverflow_H">{{ row.hours }}</span>
              </template>
            </el-table-column>
            <el-table-column label="台班金额" prop="lineRemark" align='center' showOverflowTooltip>
              <template v-slot="{ row, $index }">
                <el-form-item v-if="row.isEdit" style="margin-bottom: 0;">
                  <el-input maxlength="20" v-model="row.teamPrice" placeholder="请输入"></el-input>
                </el-form-item>
                <span v-else class="overoverflow_H">{{ row.teamPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100px" fixed="right" align="center">
              <template v-slot="{ row, $index }">
                <template v-if="row.isEdit">
                  <el-button type="text" @click="onSave(row)">保存</el-button>
                  <el-button type="text" @click="onCancel($index)">取消</el-button>
                </template>
                <template v-else>
                  <el-button type="text" @click="onEdit(row)">编辑</el-button>
                  <el-button type="text" @click="onDelete($index)">删除</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

      <!-- <div class="flex"> -->
      <el-form-item prop="headRemark" label="备注信息">
        <el-input v-model="info.headRemark" placeholder="请输入备注信息" type="textarea" show-word-limit :rows="3"
          maxlength="200" />
      </el-form-item>
      <el-form-item label="现场图片" prop="fileList">
        <div class="imgList">
          <div class="imgBlock" v-for="(item, index) in info.fileList" :key="index">
            <el-image :src="item.filePrefix + item.fileUrl" :preview-src-list="[item.filePrefix + item.fileUrl]"
              fit="fill">
            </el-image>
            <span></span>
            <i class="el-icon-close" @click="imgRemove(index)"></i>
          </div>
          <UploadFile :accept="'jpeg,jpg,png'" @onSuccess="onSuccess" :slotShow='true'
            v-if="info?.fileList?.length < 6">
            <i class="el-icon-plus"></i>
            <p>上传图片</p>
          </UploadFile>
        </div>
        <div class="mt20">(最多六张)</div>
      </el-form-item>
      <!-- </div> -->
      <el-form-item>
        <el-button type="primary" @click="saveForm" :disabled='submitShow'>保存</el-button>
        <el-button @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import UploadFile from '@/components/uploadFile/Index.vue'
import { deepClone } from '@/utils/util'
const oneDecimal = (rule, value, callback) => {
  const reg = /^([1-9][0-9]*|[0-9])(\.\d)?$/
  if (value && !reg.test(value)) {
    return callback(new Error('正整数或1位小数'))
  } else if (value < 0.1 || value > 24) {
    return callback(new Error('0.1到24之间'))
  } else {
    return callback()
  }
}

const oneDecimal2 = (rule, value, callback) => {
  const reg = /^([1-9][0-9]*|[0-9])(\.\d)?$/
  if (value && !reg.test(value)) {
    return callback(new Error('正整数或1位小数'))
  } else if (value < 0.1 || value > 999.9) {
    return callback(new Error('0.1到999.9之间'))
  } else {
    return callback()
  }
}

export default {
  name: 'AddTaiBanLabor',
  components: { UploadFile },
  props: {
    id: {
      type: String,
      default: ''
    },
    addShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          const now = (new Date()).getTime()
          const sevenAfter = 91 * 24 * 3600 * 1000
          const res = now - sevenAfter
          return time.getTime() > (new Date()).getTime() || time.getTime() < res
        }
      },
      info: {
        // 基础信息
        projectId: '',
        machineTeamDate: '',
        machineTeamLines: [],
        headRemark: '',
        fileList: []
      },
      machineryData: [],
      submitShow: false,
      rules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: 'change' }
        ],
        machineTeamDate: [
          { required: true, message: '请选择台班日期', trigger: 'change' }
        ],
        machineTeamLines: [
          { required: true, message: '请输入台班机械', trigger: 'change' }
        ],
        fileList: [
          { required: true, message: '请选择现场图片', trigger: 'change' }
        ],
        machineryId: [
          { required: true, message: '请选择机械名称', trigger: 'change' }
        ],
        jobContent: [
          { required: true, message: '请输入作业内容', trigger: 'change' }
        ],
        hours: [
          { required: true, message: '请输入台班', trigger: 'change' },
          { validator: oneDecimal, trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入单价', trigger: 'change' },
          { validator: oneDecimal2, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {
    id(val) {
      val && this.getDetail()
    },
    addShow(val) {
      this.dialogVisible = val
    }
  },
  filters: {
    imgListFormat(list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((item) => {
        const str = item.fileName.split('.')
        if (imgTypeList.find((items) => items === str[str.length - 1].toLowerCase())) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    }
  },

  created() {
    this._tempRow = null
    this.loadMachineryData() // 获取机械
  },
  methods: {
    // 获取机械
    loadMachineryData() {
      this.$axios.get(this.$apis.laborManage.selectYhMachineryByList).then(res => {
        this.machineryData = res || []
        setTimeout(() => {
          if (this.$refs.table) {
            this.$refs.table.doLayout();
          }
        }, 3000)
      })
    },
    getDetail() {
      this.$axios.get(this.$apis.laborManage.selectYhMachineTeamByMachineTeamId, { machineTeamId: this.id }).then(res => {
        res.machineTeamLines.forEach((item) => {
          item.isEdit = false
        })
        this.info = res
      })
    },
    hoursChange(val, row) {
      if (/^([1-9][0-9]*|[0-9])(\.\d)?$/.test(val)) {
        row.teamPrice = val * row.price
      }
    },
    getSummaries(param) {
      const { data } = param
      let total = 0
      data.forEach((item) => {
        if (/^([1-9][0-9]*|[0-9])(\.\d)?$/.test(item.teamPrice)) {
          total += parseFloat(item.teamPrice)
        }
      })
      return ['合计', '', '', '', '', '', '', total]
    },
    onAdd() {
      if (this.info.machineTeamLines.some((item) => item.isEdit)) {
        this.$message.warning('请先保存！')
        return
      }
      this._tempRow = null
      this.info.machineTeamLines.push({
        machineryId: '',
        machineryName: '',
        specificationModel: '',
        supplierId: '',
        jobContent: '',
        teamPrice: '',
        hours: '',
        price: '',
        lineRemark: '',
        isEdit: true
      })
    },
    onCancel(index) {
      if (this._tempRow) {
        this.info.machineTeamLines.splice(index, 1, this._tempRow)
      } else {
        this.info.machineTeamLines.splice(index, 1)
      }
    },
    onEdit(row) {
      if (this.info.machineTeamLines.some((item) => item.isEdit)) {
        this.$message.warning('请先保存！')
        return
      }
      this._tempRow = deepClone(row)
      row.isEdit = true
    },
    onDelete(index) {
      this.info.machineTeamLines.splice(index, 1)
    },
    // 选择机械名称
    onMachineryChange(machineryId, row) {
      const data = this.machineryData.find((item) => item.machineryId === machineryId)
      row.machineryId = data.machineryId
      row.machineryName = data.machineryName
      row.specificationModel = data.specificationModel
      row.supplierId = data.supplierId
      row.supplierName = data.supplierName
      row.whetherOil = data.whetherOil
      row.price = data.unitPrice
    },
    onSave(row) {
      if (!row.machineryId) {
        this.$message.warning('请选择机械名称！')
        return
      }
      if (!row.jobContent) {
        this.$message.warning('请输入作业内容！')
        return
      }
      if (!row.hours) {
        this.$message.warning('请输入台班！')
        return
      }
      if (!row.price) {
        this.$message.warning('请输入单价！')
        return
      }
      if (!row.teamPrice) {
        this.$message.warning('请输入台班金额！')
        return
      }
      if (!/^([1-9][0-9]*|[0-9])(\.\d)?$/.test(row.teamPrice)) {
        this.$message.warning('台班金额格式错误！')
        return
      }
      row.isEdit = false
    },
    saveForm() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          if (this.info.machineTeamLines.some((item) => item.isEdit)) {
            this.$message.warning('请先保存！')
            return
          }
          this.submitShow = true
          const params = deepClone(this.info)
          params.machineTeamLines = params.machineTeamLines.map((item) => {
            return {
              machineryId: item.machineryId,
              jobContent: item.jobContent,
              hours: item.hours,
              price: item.price,
              teamPrice: item.teamPrice,
              lineRemark: item.lineRemark
            }
          })
          const urls = this.id ? this.$apis.laborManage.updateYhMachineTeam : this.$apis.laborManage.insertYhMachineTeam
          this.$axios.post(urls, params).then(() => {
            this.$message.success('保存成功')
            this.handleClose()
            this.$emit('success')
            this.$emit('getTodayEvent')
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    },
    // 文件上传成功返回
    onSuccess(file) {
      (this.info).fileList.push(file)
    },
    imgRemove(index) {
      this.info.fileList.splice(index, 1)
    },
    handleClose() {
      this.$emit('update:addShow', false)
      this.$emit('update:id', '')
      this.operateIndex = 'unOperated'
      this.info = {
        // 基础信息
        projectId: '',
        machineTeamDate: '',
        machineTeamLines: [],
        headRemark: '',
        fileList: []
      }
      this.$refs.formData.resetFields()
    }
  }

}
</script>

<style lang="scss">
.machinery-select {
  .el-select-dropdown__item {
    height: 60px !important;
  }

  .machinery-item {
    display: flex;
    flex-direction: column;
    height: 60px !important;

    .line1 {
      display: flex;
      justify-content: space-between;

      span {
        line-height: 28px;

        &:nth-child(2) {
          margin-left: 10px;
        }
      }
    }

    .line2 {
      display: flex;
      justify-content: space-between;

      span {
        line-height: 28px;
        font-size: 12px;
        color: #999999;
      }
    }
  }
}
</style>
<style scoped lang="scss">
@import "@/assets/scss/color";

.global-form2 .el-textarea {
  width: 380px;
}

::v-deep .el-dialog {
  // height: 718px !important;
}

.overoverflow_H {
  overflow: hidden;
}

::v-deep .el-table__body {
  .cell {
    overflow: visible !important;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-input {
    width: 100% !important;
  }

  .el-select {
    width: 100% !important;
  }

  .el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 93%;
    left: 0px;
    z-index: 9999;
    // position: relative;
  }

  .el-table__row {
    height: 62px;
  }
}

.flex {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    flex: 1 !important
  }
}

.imgList {
  width: 100%;
  min-height: 104px;
  display: flex;
  margin-top: 15px;
  flex-wrap: wrap;

  .imgListTitle {
    margin-right: 10px;
  }

  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin: 0 10px 10px 0 !important;

    .el-image,
    img,
    video {
      width: 100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }

    i:hover {
      color: #ffffff98;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding: 25px 10px;

    i {
      font-size: 22px;
      color: #999;
      margin-bottom: 7px;
    }
  }

  ::v-deep .el-upload {
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;
  }
}
</style>
